import { SurveyComponent, Survey } from "@tree-company/tree-query";
import { useContext, useEffect, useMemo, useState } from "react";
import { bpartTitleForStreet, surveySettingsForFlow } from "../surveys";
import { LocaleContext } from "../components/localization_wrapper";
import { NEXT_STREET_EVENT } from "../constants";

export function FlowSurvey({ apiClient, flow, initialStreet }) {
  const i18n = useContext(LocaleContext);
  const [street, setStreet] = useState(initialStreet || null);
  const [restartVersion, setRestartVersion] = useState(0);

  useEffect(() => {
    setStreet(initialStreet || null);
    setRestartVersion((version) => version + 1);
  }, [flow, initialStreet]);

  useEffect(() => {
    const restartHandler = (event) => {
      if (event.detail?.flow !== flow) return;

      setStreet(event.detail?.street || null);
      setRestartVersion((version) => version + 1);
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    };

    window.addEventListener(NEXT_STREET_EVENT, restartHandler);
    return () => window.removeEventListener(NEXT_STREET_EVENT, restartHandler);
  }, [flow]);

  const treesponse = useMemo(() => {
    const initialAnswers = { flow };
    if (street) {
      initialAnswers.street = street;
      initialAnswers.bpart_title = bpartTitleForStreet(flow, street, i18n);
    }

    return apiClient.initTreesponse({
      language: i18n.locale,
      surveyVersion: "v1",
      initialAnswers,
    });
  }, [apiClient, flow, i18n.locale, restartVersion, street]);

  const survey = useMemo(() => {
    const s = new Survey(surveySettingsForFlow(flow, i18n), treesponse);
    if (street) {
      s.nextPage();
    }
    // If we are on the "like" page and there are only two comments, redirect to next page.
    s.settings.pages
      .find((page) => page.key === "like")
      .sections.find((section) => section.key === "like").onOptionsLoaded = (
      options,
    ) => {
      if (options.length < 2) {
        s.nextPage();
      }
    };
    return s;
  }, [flow, i18n, restartVersion, treesponse]);

  return (
    <SurveyComponent
      key={`${flow}-${street || "none"}-${restartVersion}-${i18n.locale}`}
      survey={survey}
    />
  );
}
